import { Spinner } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './Loader.css';

interface ILoaderProps {
  size?: number;
}

export const Loader = ({ size = 32 }: ILoaderProps) => {
  const sizeStyle = React.useMemo(() => ({ width: size, height: size }), []);

  return (
    <div className={styles['wrapper']} style={sizeStyle}>
      <Spinner size={size} />
    </div>
  );
};
